import { render, staticRenderFns } from "./FullNameAndSocialName.vue?vue&type=template&id=45840210&"
import script from "./FullNameAndSocialName.vue?vue&type=script&lang=js&"
export * from "./FullNameAndSocialName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports